const legalData = (state, data) => {
  ///////////////////////Lista de artículos/////////////////////////////////
  try {
    if (Array.isArray(state?.listaArticulos)) {
      if (state?.listaArticulos[0]?.nombre != undefined) {
        for (let item of state.listaArticulos) {
          data.listaArticulos =
            data.listaArticulos == "" ? item.nombre : data.listaArticulos + ", " + item.nombre;
        }
      } else {
        for (let item of state.listaArticulos) {
          data.listaArticulos =
            data.listaArticulos == ""
              ? item.Numeroarticulo
              : data.listaArticulos + ", " + item.Numeroarticulo;
        }
      }
    }
  } catch (error) {
    console.log("error", error);
  }

  ///////////////////////////////////Número de UFI////////////////////////////////////
  try {
    var UFI = state?.ActuacionUfi?.Numero;
    data.ActuacionUfi = UFI;
  } catch (e) {
    console.log("error", e);
  }

  ///////////////////Caratula o Delito////////////
  try {
    if (state?.listaCaratulas?.Nombre != undefined) {
      data.caratula = state.causaCaratula.Nombre;
    } else if (state?.listaCaratulas?.length > 0) {
      data.listaCaratulas = "";
      state.listaCaratulas.map((e) => {
        if (data.listaCaratulas !== "") {
          data.listaCaratulas += ", " + e.Nombre;
        } else {
          data.listaCaratulas = e.Nombre;
        }
      });
      data.caratula = data.listaCaratulas;
    } else if (state?.causaCaratula) {
      data.caratula = state.causaCaratula;
    }
  } catch (e) {
    console.log("error", e);
  }

  ///////////////////////////////////Fiscal////////////////////////////////////
  try {
    var prosecutor = state?.prosecutor?.Denominacion;
    data.prosecutor = prosecutor;
  } catch (e) {
    console.log("error", e);
  }

  ///////////////////////////////////Ayudante fiscal////////////////////////////////////
  try {
    var assistant = state?.assistant?.Denominacion;
    data.assistant = assistant;
  } catch (e) {
    console.log("error", e);
  }

  try {
    data.modusOperandi =
      typeof modusOperandi == "object" ? state.modusOperandi.Nombre : state.modusOperandi;
  } catch (e) {
    console.log("error", e);
  }

  try {
    if (state?.causaJuzgado?.Nombre) {
      data.juzgado = state.causaJuzgado.Nombre;
    } else {
      if (state?.causaJuzgado) {
        //la siguiente linea, es por que cuando se ingresa por teclado un string vacio '', se guarda un objeto con un campo Nombre que es igual a ese string
        data.juzgado =
          typeof state.causaJuzgado == "object" ? state.causaJuzgado.Nombre : state.causaJuzgado;
      }
    }
  } catch (e) {
    console.log("error", e);
  }
  let causaNumero = state?.causaNumero;
  if (typeof causaNumero === "number") {
    // Si ya es un número, se guarda directo
    data.causaNumero = causaNumero;
  } else {
    let numeroProcesado = causaNumero?.split("/")[0];
    data.causaNumero = Number(numeroProcesado); // Convertimos a número
  }
  ///////////////////Sitio////////////Add commentMore actions
  try {
    data.Sitio = state.Sitio;
  } catch (e) {
    console.log("error", e);
  }
};
export default {
  legalData,
};
